(() => {
 const stage = document.querySelector('.whisk-stage');
 const button = document.querySelector('#wave-toggle');
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 let paused = reduced.matches;
 let userPaused = false;
 let ready = false;
 let restTimer;
 if (!window.lottie || !window.WYW_GIFT_WAVE) return;
 const wave = lottie.loadAnimation({
  container: document.querySelector('#whisk-wave'), renderer: 'svg',
  animationData: structuredClone(window.WYW_GIFT_WAVE), loop: false, autoplay: false,
  rendererSettings: { preserveAspectRatio: 'xMidYMid meet' }
 });
 wave.setSpeed(.75);
 function label() {
  button.setAttribute('aria-pressed', String(paused));
  button.setAttribute('aria-label', paused ? 'Play whisk animation' : 'Pause whisk animation');
  button.title = paused ? 'Play whisk animation' : 'Pause whisk animation';
 }
 function play() {
  if (!ready || paused || document.hidden) return;
  clearTimeout(restTimer);
  if (wave.currentFrame >= wave.totalFrames - 2) wave.goToAndPlay(0, true);
  else wave.play();
 }
 function stop() { clearTimeout(restTimer); wave.pause(); }
 wave.addEventListener('DOMLoaded', () => {
  // The wave swings past the original export canvas. Keep its display size
  // while giving the renderer transparent clearance on every side.
  const clipRect = document.querySelector('#whisk-wave svg clipPath rect');
  if (clipRect) {
   const padding = 150;
   clipRect.setAttribute('x', String(-padding));
   clipRect.setAttribute('y', String(-padding));
   clipRect.setAttribute('width', String(window.WYW_GIFT_WAVE.w + padding * 2));
   clipRect.setAttribute('height', String(window.WYW_GIFT_WAVE.h + padding * 2));
  }
  ready = true;
  stage.classList.add('ready');
  button.hidden = false;
  wave.goToAndStop(0, true);
  label(); play();
 });
 wave.addEventListener('complete', () => {
  if (!paused && !document.hidden) restTimer = setTimeout(play, 4800);
 });
 button.addEventListener('click', () => {
  paused = !paused; userPaused = paused; label();
  if (paused) stop(); else play();
 });
 reduced.addEventListener('change', () => {
  paused = reduced.matches || userPaused; label();
  if (paused) { stop(); wave.goToAndStop(0, true); } else play();
 });
 document.addEventListener('visibilitychange', () => {
  if (document.hidden) stop(); else play();
 });
})();
